













































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import HasilPemeriksaanUsgInputModal from "@/components/modal/HasilPemeriksaanUsgInputModal.vue";
import { storeHasilPemeriksaanUsg } from "@/store/modules/HasilPemeriksaanUsgStore";
import HasilPemeriksaanUsgSvc from "@/services/HasilPemeriksaanUsg";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd,
    HasilPemeriksaanUsgInputModal
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardHasilPemeriksaanUsg extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalInput = false;
  modalTtd = false;
  editData: any = null;
  signItem: any = null;
  deleting = false;
  uploadingId: number | null = null;
  uploadTarget: any = null;

  mounted() {
    this.reload();
  }

  reload() {
    if (this.register) {
      storeHasilPemeriksaanUsg.getByRegister(this.register);
    }
  }

  get items() {
    return storeHasilPemeriksaanUsg.items;
  }

  get loading() {
    return storeHasilPemeriksaanUsg.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get canMake() {
    // Episode read-only (48 jam pasca resume / mode riwayat) → tidak boleh
    // buat/ubah/hapus hasil USG. canEdit() ikut nonaktif karena cek canMake.
    if (this.readOnly) return false;
    const profesi = (this.stateuser.profesi || "").toLowerCase();
    return ["dokter", "perawat", "bidan"].includes(profesi);
  }

  canEdit(item) {
    if (!this.canMake) return false;
    return !item.dokter || item.dokter.id == this.stateuser.id;
  }

  bisaHapus(item) {
    if (!item.signed) return this.canEdit(item);
    if (!this.canMake) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [{ ditandatangani: item.signed, penandaTanganId: item.dokter && item.dokter.id }],
      this.stateuser.id
    );
  }

  tooltipTtd(item) {
    if (this.canSignItem(item)) return "Tandatangani sebagai Dokter Pemeriksa";
    if (!item.dokter) return "Dokter pemeriksa belum dipilih — ubah hasil lalu pilih dokter pemeriksa";
    return `Menunggu tanda tangan ${item.dokter.nama || "dokter pemeriksa"} — hanya akun tersebut yang dapat menandatangani`;
  }

  canSignItem(item) {
    return (
      !item.signed &&
      item.dokter &&
      this.stateuser.id == item.dokter.id
    );
  }

  labelJenis(s: string) {
    const map: Record<string, string> = {
      obstetri: "Obstetri",
      ginekologi: "Ginekologi",
      abdomen: "Abdomen",
      lain: "Lain-lain"
    };
    return map[s] || s;
  }

  formatDate(date: string | null) {
    return date ? getHumanDateTime(date) : "-";
  }

  openInput(item: any) {
    if (this.readOnly) return;
    this.editData = item;
    this.modalInput = true;
  }

  openSign(item: any) {
    this.signItem = item;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signItem) return;
    const resp = await HasilPemeriksaanUsgSvc.signDokter(this.signItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Hasil USG");
      appModule.addMsgTtd("");
      this.reload();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  onSaved(rec: any) {
    this.reload();
    if (rec && rec.id && rec.dokter_id == this.stateuser.id) {
      this.openSign({ id: rec.id });
    }
  }

  print(item: any) {
    HasilPemeriksaanUsgSvc.print(item.id);
  }

  triggerUpload(item: any) {
    this.uploadTarget = item;
    const el = this.$refs.fileInput as HTMLInputElement;
    if (el) {
      el.value = "";
      el.click();
    }
  }

  async onFileChange(e: Event) {
    const input = e.target as HTMLInputElement;
    const files = input.files;
    if (!files || !files.length || !this.uploadTarget) return;
    const item = this.uploadTarget;
    this.uploadingId = item.id;
    try {
      const res = await HasilPemeriksaanUsgSvc.uploadFoto(item.id, files[0]);
      if (res) {
        appModule.NoticeDelay("Gambar USG ditambahkan");
        this.reload();
      }
    } finally {
      this.uploadingId = null;
      this.uploadTarget = null;
    }
  }

  async removeFoto(item: any, foto: any) {
    if (!confirm("Hapus gambar ini?")) return;
    const ok = await HasilPemeriksaanUsgSvc.deleteFoto(item.id, foto.id);
    if (ok) {
      appModule.NoticeDelay("Gambar dihapus");
      this.reload();
    }
  }

  async remove(item: any) {
    if (this.readOnly) return;
    if (!this.bisaHapus(item)) return;
    if (!confirm("Anda yakin akan menghapus Hasil USG ini?")) return;
    if (this.deleting) return;
    this.deleting = true;
    try {
      const resp = await HasilPemeriksaanUsgSvc.destroy(item.id);
      if (resp?.status == "1" || resp?.status == 1) {
        appModule.NoticeDelay(resp.message || "Berhasil menghapus");
        this.reload();
      }
    } finally {
      this.deleting = false;
    }
  }
}
